import React from 'react';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import { JoyTypeLevels } from '../types';

export function Centered({ children }: { children: React.ReactNode }) {
    return (
        <Stack direction="row" justifyContent="center">
            {children}
        </Stack>
    );
}

export function CenteredText({children, level="body-xs"}: {children: React.ReactNode, level?: JoyTypeLevels }) {
    return (
        <Centered>
            <Typography level={level}>{children}</Typography>
        </Centered>
    )
}
export default Centered;
